var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.isLoggedIn && _vm.isServerAvailable
        ? _c(
            "b-sidebar",
            {
              attrs: {
                id: "sidebar-1",
                shadow: "",
                "no-header": "",
                "no-enforce-focus": "",
                "no-close-on-route-change": "",
                width: "260px"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "footer",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "sidebar-footer-menu" },
                          [
                            _c(
                              "b-nav-item-dropdown",
                              {
                                staticClass: "user-profile-dropdown",
                                attrs: { dropup: "", "no-caret": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "button-content",
                                      fn: function() {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "user-info-content"
                                            },
                                            [
                                              _c("v-icon", {
                                                staticClass: "mr-1",
                                                attrs: {
                                                  name: "navbar/user_circle",
                                                  size: 13
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("em", [
                                                _vm._v(_vm._s(_vm.user.name))
                                              ]),
                                              _vm._v(" "),
                                              _c("v-icon", {
                                                staticClass: "ml-auto",
                                                attrs: {
                                                  name:
                                                    "buttons/chevrons_up_down",
                                                  size: 13
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  1550949146
                                )
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    class:
                                      _vm.$route.name === "Home" &&
                                      "active router-link-active",
                                    attrs: {
                                      to: { path: "/home" },
                                      variant: _vm.navVariant
                                    }
                                  },
                                  [
                                    _c("v-icon", {
                                      staticClass: "mr-1",
                                      attrs: { name: "navbar/home", size: 13 }
                                    }),
                                    _vm._v(
                                      "\n            Личный кабинет\n          "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { on: { click: _vm.logout } },
                                  [
                                    _c("v-icon", {
                                      staticClass: "mr-1",
                                      attrs: {
                                        name: "buttons/logout",
                                        size: 13
                                      }
                                    }),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("message.login.logout")) +
                                        "\n          "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2862906895
              ),
              model: {
                value: _vm.isOpenMenu,
                callback: function($$v) {
                  _vm.isOpenMenu = $$v
                },
                expression: "isOpenMenu"
              }
            },
            [
              _c(
                "div",
                { staticClass: "sidebar-brand-container" },
                [
                  _c("img", {
                    staticClass: "logo-main",
                    attrs: { src: require("../static/logo.svg"), alt: "Logo" }
                  }),
                  _vm._v(" "),
                  _c("v-icon", {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle.sidebar-1",
                        modifiers: { "sidebar-1": true }
                      }
                    ],
                    staticClass: "mr-1",
                    attrs: { name: "navbar/toggle_menu_left", size: 13 }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-list-group",
                {
                  staticClass: "menu text-menu",
                  attrs: { id: "menu", flush: "" }
                },
                [
                  _vm.hasPermTask
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.name === "Tasks" &&
                            "active router-link-active",
                          attrs: {
                            to: { name: "Tasks" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/tasks", size: 13 }
                          }),
                          _vm._v("\n        Заявки на смену\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermOrganization
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/organizations" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/organizations" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/organizations", size: 13 }
                          }),
                          _vm._v("\n        Наши организации\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermCustomer
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/customers" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/customers" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/customers", size: 13 }
                          }),
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("message.customers.title")) +
                              "\n      "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermLocation
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/locations" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/locations" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/locations", size: 13 }
                          }),
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("message.locations.title")) +
                              "\n      "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermRecruitTask
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/recruit_tasks" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/recruit_tasks" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/recruit_tasks", size: 13 }
                          }),
                          _vm._v("\n        Заявки на подбор\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermRecruitJobPosting
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/recruit_job_postings" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/recruit_job_postings" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/job_postings", size: 13 }
                          }),
                          _vm._v("\n        Объявления\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermRecruitJobPosting
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/responses" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/responses" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: {
                              name: "navbar/job_posting_responses",
                              size: 13
                            }
                          }),
                          _vm._v("\n        Отклики\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermWorker
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/workers" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/workers" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/users", size: 13 }
                          }),
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("message.workers.title")) +
                              "\n      "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermStaff
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/staffs" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/staffs" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/staffs", size: 13 }
                          }),
                          _vm._v("\n        Штатный персонал\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermStaff
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/invoices" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/invoices" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/invoices", size: 13 }
                          }),
                          _vm._v("\n        Выставление счёта\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermStaff
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/reconciliation_acts" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/reconciliation_acts" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: {
                              name: "navbar/reconciliation_acts",
                              size: 13
                            }
                          }),
                          _vm._v("\n        Акты сверки\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermStatistic
                    ? _c(
                        "b-list-group-item",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle:collapse-statistics",
                              arg: "collapse-statistics"
                            }
                          ],
                          attrs: { variant: _vm.navVariant }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/statistics", size: 13 }
                          }),
                          _vm._v("\n        Статистика\n        "),
                          _c(
                            "span",
                            { staticClass: "float-right when-open ml-auto" },
                            [
                              _c("v-icon", {
                                attrs: { name: "buttons/chevrons_up", size: 11 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "float-right when-closed ml-auto" },
                            [
                              _c("v-icon", {
                                attrs: {
                                  name: "buttons/chevrons_right",
                                  size: 11
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    { attrs: { id: "collapse-statistics" } },
                    [
                      _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.name === "ManagerStatistics" &&
                            "active router-link-active",
                          attrs: {
                            to: { name: "ManagerStatistics" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("span", { staticClass: "text-small" }, [
                            _vm._v(
                              "\n              По менеджерам\n            "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.name === "CustomerStatistics" &&
                            "active router-link-active",
                          attrs: {
                            to: { name: "CustomerStatistics" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("span", { staticClass: "text-small" }, [
                            _vm._v(
                              "\n              По заказчикам\n            "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasPermAnalytic
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/analytics" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/analytics" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/analitics", size: 13 }
                          }),
                          _vm._v("\n        Аналитика\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermReport
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/reports" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/reports" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/reports", size: 13 }
                          }),
                          _vm._v("\n        Отчёты\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermRegister
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.name === "Register" &&
                            "active router-link-active",
                          attrs: {
                            to: { name: "Register" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/register", size: 13 }
                          }),
                          _vm._v("\n        Общий реестр\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermUser
                    ? _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.path === "/users" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/users" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/user_cog", size: 13 }
                          }),
                          _vm._v("\n        Пользователи\n      ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermCatalog
                    ? _c(
                        "b-list-group-item",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle:collapse-catalogs",
                              arg: "collapse-catalogs"
                            }
                          ],
                          attrs: { variant: _vm.navVariant }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "navbar/catalogs", size: 13 }
                          }),
                          _vm._v("\n        Справочники\n        "),
                          _c(
                            "span",
                            { staticClass: "float-right when-open ml-auto" },
                            [
                              _c("v-icon", {
                                attrs: { name: "buttons/chevrons_up", size: 11 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "float-right when-closed ml-auto" },
                            [
                              _c("v-icon", {
                                attrs: {
                                  name: "buttons/chevrons_right",
                                  size: 11
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    { attrs: { id: "collapse-catalogs" } },
                    [
                      _vm.hasPermCatalogTown
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/town_catalogs" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/town_catalogs" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v("\n            Города\n          ")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogCitizenship
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/citizenships" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/citizenships" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v("\n            Гражданства\n          ")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogWorkType
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/work_type_catalogs" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/work_type_catalogs" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v("\n            Виды работ\n          ")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogSource
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/marketing_sources" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/marketing_sources" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Маркетинговые источники\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogWorkerSource
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/worker_sources" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/worker_sources" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Источники исполнителей\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogWorkerStatus
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/worker_statuses" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/worker_statuses" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Статусы исполнителей\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogEmploymentCategory
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/employment_categories" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/employment_categories" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Категория занятости\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogDriverLicenseCategory
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path ===
                                  "/driver_license_categories" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/driver_license_categories" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Категории водительских прав\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogJobTitle
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/job_titles" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/job_titles" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v("\n            Должности\n          ")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermRole
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/user_roles" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/user_roles" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v("\n            Роли\n          ")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogLocationCostType
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/location_cost_types" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/location_cost_types" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Типы расходов объекта\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogLocationStatus
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/location_statuses" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/location_statuses" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Статусы объекта\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogWorkerCostType
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/worker_cost_types" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/worker_cost_types" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Типы расходов исполнителя\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogDepartment
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/departments" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/departments" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Подразделения\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogWorkService
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/work_services" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/work_services" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Услуги самозанятых\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogVacancy
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/vacancies" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/vacancies" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v("\n            Вакансии\n          ")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermLocationVacancy
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path ===
                                  "/recruit_location_vacancies" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/recruit_location_vacancies" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Шаблоны вакансий\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogProjectStatus
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/project_statuses" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/project_statuses" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Статусы проектов\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermRecruitJobPostingStatuses
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/job_posting_statuses" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/job_posting_statuses" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Статусы объявлений\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermRecruitTaskStatuses
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/recruit_task_statuses" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/recruit_task_statuses" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Статусы заявок на подбор\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogTaskGroup
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/task_groups" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/task_groups" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Группы заявок\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogLeadStatus
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/lead_statuses" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/lead_statuses" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Статусы лидов\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogCustomerStatus
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/customer_statuses" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/customer_statuses" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Статусы заказчиков\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogLeadSource
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/lead_sources" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/lead_sources" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Источники лидов\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogRecruitTag
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/recruit_tags" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/recruit_tags" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Теги заявки на подбор\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalogRecruitResponseStatus
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path ===
                                  "/recruit_response_statuses" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/recruit_response_statuses" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "navbar/catalog", size: 13 }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n            Статусы откликов\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn && _vm.isServerAvailable
        ? _c(
            "div",
            {
              staticClass: "main-layout",
              class: { "sidebar-closed": !_vm.isOpenMenu }
            },
            [
              _c(
                "main",
                { staticClass: "content-frame" },
                [_c("router-view")],
                1
              )
            ]
          )
        : _c("div", { staticClass: "auth-layout" }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("ErrorsModalWindow", {
        attrs: {
          offline: _vm.noConnectionError,
          "not-found": _vm.notFoundError,
          forbidden: _vm.forbiddenError
        },
        on: { hidden: _vm.resetErrorStates },
        model: {
          value: _vm.showErrorModal,
          callback: function($$v) {
            _vm.showErrorModal = $$v
          },
          expression: "showErrorModal"
        }
      }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "app" } }),
      _vm._v(" "),
      !_vm.isOpenMenu && _vm.isLoggedIn && _vm.isServerAvailable
        ? _c(
            "portal",
            { attrs: { to: "sidebar-toggle" } },
            [
              _c("v-icon", {
                staticClass: "sidebar-trigger-internal mr-3",
                attrs: { name: "navbar/toggle_menu_right", size: 13 },
                on: {
                  click: function($event) {
                    _vm.isOpenMenu = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 